// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type Props = {|
  children?: Node,
  redesign?: boolean,
|}

export function VoucherNumberBox({ children, redesign=null }: Props): Node {
  return (
    <VoucherNumberWrapper redesign={redesign}>
      {children}
    </VoucherNumberWrapper>
  );
}

const VoucherNumberWrapper = styled.div`
  &:empty{
    display: none;
  }
  border: 1px solid ${props => props.theme.colors.gray(92)};
  border-radius: 5px;
  ${props => props.redesign === true ? 'width: 100%' : 'padding: 15px'};
`;
